export const filterInlineImages = (contents: string, images: string[]) => {
	const filteredImages = images.filter(imageID => {
		const regex = new RegExp(`\\b${imageID}\\b`, 'g');
		return !regex.test(contents);
	});
	return filteredImages;
};
